import { FC, useState } from 'react';
import { Search } from '@silverfort/sf-components';

export interface UsersTableSearchProps {
    onSearchChange: (search: string) => void;
}

const UsersTableSearch: FC<UsersTableSearchProps> = ({ onSearchChange }) => {
    const [searchText, setSearchText] = useState('');

    const handleChange = (search: string) => {
        setSearchText(search);
        onSearchChange(search);
    };

    return <Search border text={searchText} placeholder="Search user" onChange={handleChange} />;
};

export default UsersTableSearch;
